import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { PartnerBaseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-base-dto';
import { ServiceaftaleFilter, ServiceordreFilter } from '../../aftale/models';

@Component({
    selector: 'app-partner-filter',
    templateUrl: './partner-filter.component.html',
    styleUrls: ['./partner-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartnerFilterComponent implements OnInit, OnDestroy, OnChanges {
  unsubscribe$ = new Subject<void>();

  partnerCtrl = new UntypedFormControl();

  filteredPartners: Observable<PartnerBaseDto[]>;
  selectedPartners: PartnerBaseDto[] = [];

  @Input() partners: PartnerBaseDto[];

  @Input() filter: ServiceaftaleFilter | ServiceordreFilter;

  @Output() partnerChange: EventEmitter<number[]> = new EventEmitter();

  @ViewChild('partnerInput') partnerInput: ElementRef<HTMLInputElement>;
  @ViewChild('partnerAuto') matAutocomplete: MatAutocomplete;

  constructor() {
    this.filteredPartners = this.partnerCtrl.valueChanges.pipe(
      takeUntil(this.unsubscribe$),
      map((partner) => (partner ? this._filter(partner) : this.partners.slice().map((y) => y)))
    );
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.partners && this.partners) {
      this.selectedPartners = this.filter.partnerNos.map((partnerNo) => this.partners.find((x) => x.partnerNo == partnerNo));
    }
    if (changes.filter && this.partners) {
      this.selectedPartners = this.filter.partnerNos.map((partnerNo) => this.partners.find((x) => x.partnerNo == partnerNo));
    }
  }

  onPartnerChange() {
    this.filter.partnerNos = this.selectedPartners.map((x) => x.partnerNo);
    this.partnerChange.emit(this.filter.partnerNos);
  }

  removePartner(partner: PartnerBaseDto): void {
    const index = this.selectedPartners.indexOf(partner);

    if (index >= 0) {
      this.selectedPartners.splice(index, 1);
    }
    this.onPartnerChange();
  }

  partnerSelected(event: MatAutocompleteSelectedEvent): void {
    var p = this.partners.find((x) => x.name == event.option.viewValue);
    if (this.selectedPartners.find((x) => x.partnerNo == p.partnerNo)) {
    } else {
      this.selectedPartners.push(p);
    }

    this.partnerInput.nativeElement.value = '';
    this.partnerCtrl.setValue(null);
    this.onPartnerChange();
  }

  private _filter(value: string): PartnerBaseDto[] {
    if (typeof value !== 'string') return;
    return this.partners.filter(
      (option) =>
        option.name.replace(/\s/g, '').toLowerCase().indexOf(value.replace(/\s/g, '').toLowerCase()) >= 0 &&
        !this.selectedPartners.find((x) => x.partnerNo == option.partnerNo)
    );
  }
}
